export const STATUS_STEPS = ["Pending", "Processing", "Shipped", "Delivered"];

export const formatShippingMethod = (method) =>
  method === "pickup" ? "Pickup station" : "Door delivery";

export const formatNgn = (amount) =>
  (amount || 0).toLocaleString("en-US", { style: "currency", currency: "NGN" });

export const formatPaymentMethod = (order) => {
  if (order?.paymentDetails?.paymentMethod === "pay_on_delivery") {
    return "Pay on delivery";
  }
  return order?.paymentStatus === "paid" ? "Paid online" : order?.paymentStatus || "Pending";
};

export const isPayOnDeliveryOrder = (order) =>
  order?.paymentDetails?.paymentMethod === "pay_on_delivery";
